import { useTranslation } from 'react-i18next'

import { CopyIcon, DotsThreeCircleVerticalIcon, PencilSimpleIcon, TrashIcon } from '@phosphor-icons/react'

import { ButtonMenu, IconButton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const ActionsMenu = ({ rule, onEdit, onDuplicate, onDelete }) => {
  const { t } = useTranslation()

  return (
    <Styles.Container>
      <ButtonMenu
        stopPropagation
        menuItems={[
          {
            label: (
              <Styles.MenuItem>
                <PencilSimpleIcon /> {t('Editar')}
              </Styles.MenuItem>
            ),
            onClick: () => onEdit(rule),
          },
          {
            label: (
              <Styles.MenuItem>
                <CopyIcon /> {t('Duplicar')}
              </Styles.MenuItem>
            ),
            onClick: () => onDuplicate(rule),
          },
          {
            label: (
              <Styles.MenuItem>
                <TrashIcon /> {t('Eliminar')}
              </Styles.MenuItem>
            ),
            onClick: () => onDelete(rule),
          },
        ]}
        renderButton={onClick => (
          <IconButton
            variant="text"
            onClick={onClick}
            icon={<DotsThreeCircleVerticalIcon size={24} weight="light" />}
          />
        )}
      />
    </Styles.Container>
  )
}

export default ActionsMenu
